import React from 'react';
import { Box } from '@mui/material';

import SlideElement from './SlideElement';

import type { ResolvedTheme, Slide } from '@/shared/types/slide';
import { SLIDE_PAGE_WIDTH, SLIDE_PAGE_HEIGHT } from '@/shared/types/slide';
import { buildRenderElements, resolveSlideBackground } from '@/shared/theming/resolve';

// ---------------------------------------------------------------------------
// SlideThumbnail
//
// A non-interactive, pixel-faithful mini-render of one slide at a given width,
// using the exact editor render path (`buildRenderElements` + `SlideElement`) so
// previews — including theme decoration — match the canvas. Shared by the
// thumbnail panel and the theme picker (Phase 2 §7.2).
// ---------------------------------------------------------------------------

interface SlideThumbnailProps {
  slide: Slide;
  theme: ResolvedTheme;
  /** Rendered width in px; height follows the 16:9 page ratio. */
  width: number;
}

const SlideThumbnail: React.FC<SlideThumbnailProps> = ({ slide, theme, width }) => {
  const scale = width / SLIDE_PAGE_WIDTH;
  const height = width * (SLIDE_PAGE_HEIGHT / SLIDE_PAGE_WIDTH);

  return (
    <Box
      sx={{
        width,
        height,
        position: 'relative',
        overflow: 'hidden',
        bgcolor: resolveSlideBackground(slide, theme),
      }}
    >
      <div
        style={{
          width: SLIDE_PAGE_WIDTH,
          height: SLIDE_PAGE_HEIGHT,
          transform: `scale(${scale})`,
          transformOrigin: 'top left',
          position: 'absolute',
          pointerEvents: 'none',
        }}
      >
        {buildRenderElements(slide, theme).map((el) => (
          <SlideElement
            key={el.id}
            element={el}
            isSelected={false}
            zoom={100}
            onSelect={() => {}}
          />
        ))}
      </div>
    </Box>
  );
};

export default SlideThumbnail;
